import React from 'react';
import PropTypes from 'prop-types';

const Callout = ({ children, helperClass }) => {

  return (
    <section className={ `site-section ${ helperClass }` }>
      <div className="container">{ children }</div>
    </section>
  );

};

Callout.propTypes = {
  children: PropTypes.array.isRequired,
  helperClass: PropTypes.string,
};

export default Callout;
